class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Add a click event listener to the document to close the details when clicking outside
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  // Close <details> when focus is lost and active element is not an <a> tag
  onFocusOut() {
    setTimeout(() => {
      const activeElement = this.mainDetailsToggle.querySelector('a');
      if (activeElement.tagName !== 'A') {
        this.close();
      }
    });
  }

  // Handle <details> toggle animations
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  // Close <details> by removing the 'open' attribute and setting aria-expanded to false
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  // Check if click happened outside <details> and close it if it did
  onDocumentClick(event) {
    const detailsElement = this.mainDetailsToggle;

    // If the click target is not inside the <details> or its descendants, close it
    if (!detailsElement.contains(event.target)) {
      this.close();
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
